import { createModule } from './modules';

export class RoomsModule extends createModule('rooms') {
  constructor(syncClient) {
    super(syncClient);
    this.syncClient = syncClient;

    this.packetHandlers = {};
  }

  enter(room) {
    this.syncClient.sendPacket('$rooms', 'ENTER_ROOM', room);
  }

  leave(room) {
    this.syncClient.sendPacket('$rooms', 'LEAVE_ROOM', room);
  }

  set(rooms) {
    this.syncClient.sendPacket('$rooms', 'SET_ROOMS', rooms);
  }
}
